// Japanese UI labels — STUB, flagged for translation.
// Empty by design: falls back to English (en.js) per key. Human translation
// only. Included as a launch stub specifically to prove the layout holds for a
// non-Latin script. Copy the key structure from en.js, translate, then flip
// `translated: true` in i18n/languages.js.
export default {}
